import React, { useState, useEffect } from "react";
import { Button, Select, Form, Input, Transfer, Drawer, Typography, notification } from "antd";
import axiosInstance from "utilities/axios";


const { Text } = Typography;

const AddDivisionForm = ({ open, onClose, onChange }) => {
    const [form] = Form.useForm();

    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [regionOptions, setRegionOptions] = useState([]);

    const [selectedDivision, setSelectedDivision] = useState(null);
    const [divisionOptions, setDivisionOptions] = useState([]);
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [targetKeys, setTargetKeys] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);

    useEffect(() => {
        axiosInstance
          .get("/employees")
          .then((response) => {
            setEmployeeOptions(response.data);
          });

        axiosInstance
          .get("/divisions")
          .then((response) => {
            setDivisionOptions(response.data);
          });
    }, []);

    const onSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
        setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    };

    const handleTransferChange = (nextTargetKeys, direction, moveKeys) => {
        setTargetKeys(nextTargetKeys);

        if (direction === 'left') {
            setSelectedRegions([...selectedRegions, ...regionOptions.filter((region) => moveKeys.includes(region.regionCode))]);
        }
    };

    const onFinish = (values) => {
        axiosInstance
            .post("/divisions", {
                divisionCode: values.code,
                divisionName: values.name,
                dsdInitials: values.employee,
                regions: selectedRegions.map((region) => region.regionCode)
            })
            .then(() => {
                notification.success({
                    message: 'Division Created',
                    description: 'The division has been successfully created.'
                });
                onChange();
                onClose();
            })
            .catch((error) => {
                notification.error({
                    message: 'Failed to create division',
                    description: error.response.data.error
                });
            });
    };

    const handleDivisionSelect = (value) => {
        setSelectedDivision(value);
    
        axiosInstance
          .get(`/divisions/${value}`)
          .then((response) => {
            const filteredRegions = response.data.regions.filter((region) => !selectedRegions.some((selectedRegion) => selectedRegion.regionCode === region.regionCode));
            setRegionOptions([...selectedRegions, ...filteredRegions]);
            setTargetKeys(filteredRegions.map((region) => region.regionCode));
          })
          .catch((err) => {
            notification.error({
              message: "Error Fetching Regions",
              description: err.response.data.error,
            });
          });
    };

    return (
        <Drawer
            title="Add Division"
            open={open}
            onClose={onClose}
            footer={[]}
            width={500}
        >
            <Form
                form={form}
                layout='vertical'
                onFinish={onFinish}
            >
                <Form.Item
                    name="code"
                    label="Division Code"
                    rules={[ 
                        {required: true, message: 'Please enter a division code'},
                        {max: 10, message: 'Division code must be less than 10 characters'}
                    ]}
                >
                    <Input placeholder="Enter division code"/>
                </Form.Item>
                <Form.Item
                    name="name"
                    label="Division Name"
                    rules={[
                        {required: true, message: 'Please enter a division name'},
                        {max: 40, message: 'Division name must be less than 40 characters'}
                    ]}
                >
                    <Input placeholder="Enter division name" />
                </Form.Item>
                <Form.Item 
                    name='employee'
                    label="Select Divisional Sales Director"
                    rules={[{ required: true, message: 'Please select an employee' }]}
                >
                    <Select
                        showSearch
                        placeholder="Select an employee"
                        style={{ width: '100%' }}
                        filterOption={(input, option) => {
                            const optionData = employeeOptions.find(
                                (opt) => opt.initials === option.value
                            );
                            if (!optionData) {
                                return false;
                            }
                            return (
                                optionData.firstName.toLowerCase().includes(input.toLowerCase()) ||
                                optionData.lastName.toLowerCase().includes(input.toLowerCase()) ||
                                optionData.initials.toLowerCase().includes(input.toLowerCase())
                            );
                        }}
                    >
                        {employeeOptions.map((employee) => (
                            <Select.Option
                                key={employee.initials}
                                value={employee.initials}
                            >
                                {employee.firstName} {employee.lastName} - {employee.initials}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Text>Assign Regions</Text>
                <Select
                    placeholder="Select a division"
                    style={{ width: '100%', marginBottom: 24, marginTop: 8 }}
                    value={selectedDivision}
                    onChange={handleDivisionSelect}
                >
                    {divisionOptions.map((division) => (
                        <Select.Option
                            key={division.divisionCode}
                            value={division.divisionCode}
                        >
                            {division.divisionName} - {division.divisionCode}
                        </Select.Option>
                    ))}
                </Select>
                <Transfer
                    dataSource={regionOptions}
                    targetKeys={targetKeys}
                    selectedKeys={selectedKeys}
                    rowKey={(record) => record.regionCode}
                    onSelectChange={onSelectChange}
                    onChange={handleTransferChange}
                    on
                    render={(item) => `${item.regionCode} - ${item.regionName}`}
                    disabled={!selectedDivision}
                    titles={[null, selectedDivision]}
                    listStyle={{ width: "45%", height: 300 }}
                    style={{ width: "100%", marginBottom: 24 }}
                    locale={{ itemUnit: "Region", itemsUnit: "Regions" }}
                />
                <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                    Create New Division
                </Button>
            </Form>
        </Drawer>
    );
};

export default AddDivisionForm;